export default "__VITE_ASSET__d0UD7BQJ__"